import type { ComponentProps } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import { useWeddingGiftRegistryContext } from 'weddings/contexts/WeddingGiftRegistryContext'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children' | 'startIcon'> {
  shortLabel?: boolean
}

function AddToWeddingGiftRegistryCartCTA(props: Props) {
  const { addToWeddingGiftRegistryCartCTALabel, addToWeddingGiftRegistryCartCTALabelShort } = useWeddingGiftRegistryContext()

  const label = props.shortLabel ? addToWeddingGiftRegistryCartCTALabelShort : addToWeddingGiftRegistryCartCTALabel

  return (
    <TextButton
      kind="primary"
      size="medium"
      type="button"
      startIcon={<LineShoppingCartIcon />}
      {...props}
    >
      {label}
    </TextButton>
  )
}

export default AddToWeddingGiftRegistryCartCTA
